import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Truck = createReactComponent("Truck", ["svg", defaultAttributes, [["path", {
  d: "M10 17h4V5H2v12h3m15 0h2v-3.34a4 4 0 00-1.17-2.83L19 9h-5v8h1",
  key: "fy9sjr"
}], ["circle", {
  cx: "7.5",
  cy: "17.5",
  r: "2.5",
  key: "dg6ogh"
}], ["circle", {
  cx: "17.5",
  cy: "17.5",
  r: "2.5",
  key: "1jfk5q"
}]]]);
export default Truck;